import React from "react"

import Layout from "../layout/Layout"

import { Container, Row, Col, Button } from "react-bootstrap"

import HelmetInject from "../components/HelmetInject"

import TitleBoldLarge from "../components/typography/TitleBoldLarge"
import TitleLight from "../components/typography/TitleLight"
import ImageComplete from "../layout/parts/ImageComplete"
import vaccineLogo from "../images/vaccine.svg"

import { Link } from "gatsby"

export default function Home() {
  return (
    <>
      <HelmetInject
        title="Index of the Covid Vaccine Tracker Blog"
        contentDescription=""
      />
      <Layout>
        <Container fluid className="background-color-white">
          <Row>
            <Col className="text-center">
              <h1 className="mt-5">
                <TitleBoldLarge>
                  Index of the Covid Vaccine Tracker Blog
                </TitleBoldLarge>
              </h1>
            </Col>
          </Row>
          <Row>
            <Col className="text-center">
              <h2 className="mt-5">
                <TitleLight>Get the last covid vaccine news</TitleLight>
              </h2>
            </Col>
          </Row>
          <Row>
            <Col className="text-center mt-3">
              <ImageComplete
                alt={"Covid - 19 important news and information of corona"}
                src={vaccineLogo}
                className="img-fluid"
                width="400"
                height="400"
              />
            </Col>
          </Row>
        </Container>
        <Container fluid className="background-color-white">
          <Row>
            <Col className="text-center">
              <h3 className="mt-5">
                <Link to="/covid-vaccine-map">
                  Covid Vaccine Map and wordlwide tracker
                </Link>
              </h3>
              <h3 className="mt-5">
                <Link to="/covid-vaccine-blog/corona-news">Corona news</Link>
              </h3>
              <h3 className="mt-5">
                <Link to="/covid-vaccine-blog/corona-vaccine">
                  Corona vaccine
                </Link>
              </h3>
              <h3 className="mt-5">
                <a href="">coronavirus vaccine</a>
              </h3>
              <h3 className="mt-5">
                <a href="">covid - 19 vaccine</a>
              </h3>
              <h3 className="mt-5">
                <a href="">vaccine update</a>
              </h3>
              <h3 className="mt-5">
                <a href="">covid-19 vaccine</a>
              </h3>
              <h3 className="mt-5">
                <a href="">vaccine news</a>
              </h3>
              <h3 className="mt-5">
                <a href="">covid - 19 vaccine news</a>
              </h3>
              <h3 className="mt-5">
                <a href="">corona vaccine news</a>
              </h3>
              <h3 className="mt-5">
                <a href="">covid 19 vaccine news</a>
              </h3>
            </Col>
          </Row>
        </Container>
      </Layout>
    </>
  )
}
